<template>
    <div id="requirement-list">
    <loading :active="!pageLoaded"></loading>
        <b-card class="section">
            <div class="requirement-list-header">
                <div style="display: flex; align-items: end">
                    <ProjectFilter @changeProject="changeProjectHandler" @changeWithClosed="changeWithClosed"
                        :defaultStatus="withClosedProjects"
                        :customStyle="{ display: 'flex', justifyContent: 'center', alignItems: 'start' }"
                        :selectedProjectId="projectId" />
                    <button v-if="this.projectId" @click="configureDefaultProject" style="background-color: transparent; border: none;">
                        <!-- <b-icon icon="star-fill" style="color: orange;" /> -->
                        <b-icon :icon="defaultProjectIcon" style="color: orange;"/>
                    </button>
                </div>

                <div class="header-button-area">
                    <input type="file" ref="importFileInput" @change="importRequirement" style="display:none;">
                    <base-button style="background-color: #168D4C;" size="sm"
                        @click="clickImportButton"
                        :disabled="!projectId">Import</base-button>
                    <base-button style="background-color: #168D4C;" size="sm"
                        @click="exportRequirement"
                        :disabled="!projectId">Export</base-button>
                    <base-button style="background-color: #168D4C; margin-left:1em;" size="sm"
                        @click="downloadTemplate"
                        :disabled="!projectId">Template</base-button>
                </div>
            </div>
        </b-card>

        <b-card v-if="projectId" class="section">
            <loading :active.sync="loading" :is-full-page="false"></loading>
            <div class="d-flex justify-content-between align-items-center">
                <requirement-filter @changeFilter="handleChangeFilter" />
                <base-button variant="primary" @click="createRequirement"
                    style="width: 148px; height: 40px;">Create</base-button>
            </div>
            <div class="toggle-line"></div>
            <requirement-table :fieldsToDisplay="tableColumns" ref="requirementTable">
                <template v-if="requirements.length > 0">
                    <requirement-item v-for="(requirement, index) in requirements" :key="index"
                        v-bind="{ ...requirement }" :fieldsToDisplay="tableColumns.map(columns => columns.name)"
                        @onClick="clickRequirementItemHandler" />
                </template>
                <template v-else>
                    <empty-table-row :colspan="tableColumns.length">
                        No results found
                    </empty-table-row>
                </template>
            </requirement-table>
        </b-card>
        <empty-card v-else>
            <div style="display: flex; flex-direction: column; align-items: center;">
                <img style="width: 170px; height: 170px;" :src="pointerIcon" />
                <span>Please select a project</span>
            </div>
        </empty-card>
    </div>
</template>
<script>
import Loading from 'vue-loading-overlay';
import RefreshIcon from "@/components/chatter/icons/RefreshIcon.vue";
import ProjectFilter from '../wbs/ProjectFilter.vue';
import RequirementTable from './RequirementTable.vue';
import RequirementItem from './RequirementItem.vue';
import RequirementFilter from './RequirementFilter.vue';
import EmptyTableRow from './EmptyTableRow.vue'
import BaseButton from './BaseButton.vue';
import EmptyCard from '../common/EmptyCard.vue';
import PointerIcon from "@/assets/images/select_pointer.svg";

export default {
    name: 'RequirementList',
    components: {
        ProjectFilter, 
        RequirementTable,
        RequirementItem,
        EmptyTableRow, 
        BaseButton, 
        RequirementFilter, 
        RefreshIcon,
        EmptyCard
    },
    async created() {
        try {
            await this.$store.dispatch('chatter/retrieveAssigneeOptions');
            await this.$store.dispatch('chatter/retrieveAllProjectInfo');
            const defaultProjectId = await this.getDefaultProjectId();
            this.defaultProjectId = defaultProjectId;

            // 기선택된 프로젝트 아이디가 있다면
            if (this.projectId) {
                this.fetchRequirements();
                return;
            }
            let projectOptions = this.$store.getters['chatter/options']['projectOptions'];

            // TODO 사용자별 기본 선택 프로젝트 기능 구현 후 이 단계에서 수행
            if(defaultProjectId) {
                const findProject = projectOptions.find(project => project.projectId === defaultProjectId);
                const defaultProjectStatus = findProject.status;
                if (defaultProjectStatus === "CLOSED") {
                    this.changeWithClosed(true);
                }
                this.defaultProjectId = defaultProjectId;
                this.$store.commit('requirement/updateFilter', { projectId: defaultProjectId });
                this.fetchRequirements();
                return;
            }

            //toggle 여부에 따라 보이는 project 다르게
            // 로그인한 사용자가 참여하고 있는 Open상태의 프로젝트의 개수가 하나라면 해당 프로젝트를 기본 프로젝트로 설정
            const openProjectOptions = projectOptions.filter(project => project.status == "OPEN");
            if (openProjectOptions.length === 1) {
                const openProject = openProjectOptions[0];
                this.$store.commit('requirement/updateFilter', { projectId: openProject.projectId });
                this.fetchRequirements();
            }
            this.pageLoaded = true;
        } catch(e) {
            this.pageLoaded = true;
        } finally {
            this.pageLoaded = true;
        }
    },
    computed: {
        projectId() {
            return this.$store.getters['requirement/filter'].projectId;
        },
        type() {
            return this.$store.getters['requirement/filter'].type;
        },
        withClosedProjects() {
            return this.$store.getters['requirement/withClosedProjects'];
        },
        defaultProjectIcon() {
            return this.projectId === this.defaultProjectId ? 'star-fill' : 'star';
        },
    },
    data() {
        return {
            pageLoaded: false,
            pointerIcon: PointerIcon,
            defaultProjectId: '',
            total: 0,
            loading: false,
            requirements: [],
            tableColumns: [
                { name: 'id', sort: '', width: "7%" },
                { name: 'type', sort: '', width: "8%" },
                { name: 'title', sort: '', width: "63%" },
                { name: 'creator', sort: '', width: "11%" },
                { name: 'creationDate', sort: '', width: "11%" },
            ],
        }
    },

    methods: {
        changeProjectHandler(projectId) {
            this.$store.commit('requirement/updateFilter', { projectId: projectId });
            this.$store.commit('requirement/resetFilterFields', ['type']);

            if (this.projectId) {
                // API 호출
                this.fetchRequirements();
            }
        },
        changeWithClosed(value) {
            this.$store.commit('requirement/withClosedProjects', value);
        },
        handleChangeFilter() {
            this.fetchRequirements();
        },
        scrollToList() {
            // 테이블 요소 가져오기
            const requirementTable = this.$refs['requirementTable'];

            if (requirementTable) {
                requirementTable.$el.scrollIntoView({ behavior: 'smooth' });
            }
        },
        async fetchRequirements() {
            try {
                this.loading = true;
                const params = {
                    projectId: this.projectId,
                    type: this.type,
                }

                const response = await axios.get('chatter/retrieveRequirementList', {
                    params,
                    headers: {
                        'Accept': 'application/json',
                        'Authorization': accessToken()
                    }
                });

                const status = response.data.status;
                if (status === "200") {
                    const body = response.data.body;
                    this.total = body.total;
                    this.requirements = body.list;
                } else {
                    this.showToastMessage('danger', response.data.message);
                }
                this.loading = false;
            } catch (e) {
                this.loading = false;
            }

        },
        clickRequirementItemHandler(id) {
            this.$router.push(`/chatter/requirement/${id}`);
        },
        handleClickRefreshButton() {
            this.$store.commit('requirement/resetFilterFields', ['type']);
            this.fetchRequirements();
        },
        createRequirement() {
            if (!this.projectId) return;
            this.$router.push({
                name: 'requirementCreate',
                params: { projectId: this.projectId }
            })
        },
        clickImportButton() {
            if (!this.projectId) return;
            this.$refs.importFileInput.click();
        },
        async importRequirement(e) {
            if (!this.projectId) return;
            try {
                this.loading = true;
                const file = e.target.files[0];
                if (file) {
                    const fileName = file.name;
                    const fileExtension = fileName.substring(fileName.lastIndexOf('.') + 1).toLowerCase();

                    if (fileExtension === 'xlsx' || fileExtension === 'xls') {
                        const formData = new FormData();
                        formData.append("file", file);

                        const response = await axios.post(`chatter/importRequirement/${this.projectId}`,
                            formData,
                            {
                                headers: {
                                    'Content-Type': 'multipart/form-data',
                                    Authorization: accessToken()
                                }
                            }
                        )

                        const status = response.data.status;
                        if (status === "200") {
                            this.showToastMessage('default', '임포트가 완료되었습니다.');
                            this.handleClickRefreshButton();

                        } else {
                            this.showToastMessage('danger', `${response.data.message}`);
                        }

                    } else {
                        this.showToastMessage('danger', '올바른 파일 형식이 아닙니다. (.xlsx, .xls)')
                    }
                }
                this.$refs.importFileInput.value = '';
                this.loading = false;
            } catch (e) {
                this.showToastMessage('danger', e.message);
                this.$refs.importFileInput.value = '';
                this.loading = false;
            }

        },
        async exportRequirement() {
            if (!this.projectId) return;

            const response = await axios.get(`chatter/exportRequirement/${this.projectId}`, {
                responseType: 'blob',
                headers: { Authorization: accessToken() }
            });

            const resource = response.data;
            const url = resource ? URL.createObjectURL(resource) : null;

            if (url !== null) {
                const link = document.createElement('a');
                link.href = url;
                link.download = `Requirement-${this.projectId}.xlsx`;
                link.click();
            } else {
                this.showToastMessage('danger', '파일을 다운로드할 수 없습니다.');
            }
        },
        downloadTemplate() {
            try {
                axios.get("chatter/download/template/requirement-template.xlsx", {
                    responseType: 'blob',
                    headers: { Authorization: accessToken() }
                }).then(response => {
                    if (response.status === 200) {
                        const url = URL.createObjectURL(response.data)

                        const link = document.createElement('a');
                        if (url) {
                            link.href = url;
                            link.download = `requirement-template.xlsx`;
                            link.click();
                        }
                    }
                })
            } catch (e) {
                console.log(e);
                this.showToastMessage(e.message, 'danger');
            }
        },
        showToastMessage(type, message) {
            this.$bvToast.toast(`${message}`, {
                title: `Notification`,
                toaster: "b-toaster-bottom-center",
                solid: true,
                appendToast: false,
                autoHideDelay: 1000,
                variant: type,
            })
        },
        configureDefaultProject() {
            if (!this.projectId) return;

            const prevDefaultProjectId = this.defaultProjectId;

            if (this.projectId === this.defaultProjectId) {
                this.defaultProjectId = '';
            } else {
                this.defaultProjectId = this.projectId;
            }

            const params = {
                projectId: this.defaultProjectId
            }

            try {
                axios.post('/chatter/configureDefaultProject', params, {
                    headers: {
                        'Accept': 'application/json',
                        Authorization: accessToken()
                    }
                }).then(response => {
                    if (response.data.status === "200") {
                        this.defaultProjectId = response.data.body.projectId;
                    } else {
                        this.defaultProjectId = prevDefaultProjectId;
                    }
                })
            } catch(e) {
                this.defaultProjectId = prevDefaultProjectId;
            }
        },
        async getDefaultProjectId() {
            try {
                const response = await axios.get("/chatter/getDefaultProject", {
                    headers: {
                        'Accept': 'application/json',
                        Authorization: accessToken()
                    }
                })

                const status = response.data.status;

                if (status === "200") {
                    const defaultProjectId = response.data.body.projectId;
                    return defaultProjectId ? defaultProjectId : '';
                } else {
                    return ''
                }

            } catch(e) {
                console.log(e);
                return ''
            }
        }
    }
}

</script>
<style>
/* import font */
@import url('https://hangeul.pstatic.net/hangeul_static/css/nanum-gothic.css');

</style>

<style scoped>
.card-body {
    padding: 0;
}

.card.section {
    margin-bottom: 2rem;
    border-radius: 30px;
    -webkit-box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.05);
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.05);
    padding: calc(2.0833vw - 10px) 2.0833vw 2.0833vw;
}



* {
    font-family: 'NanumGothic';
}

td {
    vertical-align: middle;
}

.requirement-list-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.header-button-area {
    display: flex;
    gap: 0.6rem;
}

.tooltip .tooltip-inner {
    max-width: 1000px !important;
    white-space: pre-wrap !important;
    text-align: start;
}

.popover {
    max-width: 1000px !important;
}


/* button */
.btn {
    border-radius: 10px;
    font-family: 'NanumGothic';
    font-size: 14px;
    font-weight: 500;
    line-height: 150%;
}

.btn:focus {
    box-shadow: none;
}

.btn-primary {
    width: 280px;
    height: 60px;
    background-color: #2E2E38;
    color: #FFE600;
    border-color: transparent;
}

.btn-primary:hover {
    color: #FFE600;
    background-color: #0D0D17;
    border-color: transparent;
}

.btn-primary.disabled,
.btn-primary:disabled {
    color: #9C9CA8;
    background-color: #C4C4CD;
    border-color: transparent;
}

.btn-primary.small {
    width: 148px;
    height: 40px;
}

.btn-export {
    width: 100px;
    height: 40px;
    background-color: #168D4C;
    color: #fff;
    border-color: transparent;
}

.btn-export:hover {
    background-color: #006F2E;
    border-color: transparent;
}

.btn-export.disabled,
.btn-export:disabled {
    color: #62796D;
    background-color: #759483;
}

.btn.btn-line {
    position: relative;
    width: 135px;
    height: 60px;
    border: 1px solid #C4C4CD;
    background-color: transparent;
    color: #2E2E38;
    font-family: 'NanumGothic';
    font-size: 14px;
    font-weight: 500;
    line-height: 150%;
    text-align: inherit;
}

.btn.btn-line:hover {
    color: #2E2E38;
    border: 1px solid #2E2E38;
    background-color: transparent;
}

.btn.btn-line.disabled,
.btn.btn-line:disabled {
    border: 1px solid #DDDDE3;
    background-color: transparent;
}

.btn.btn-line.small {
    height: 40px;
    text-align: center;
}

.btn-refresh {
    height: auto;
    padding: 0;
}

/* 공통요소 */
.select-custom-scrollbar::-webkit-scrollbar {
    width: 12px;
    border-top: 6px solid transparent;
    border-bottom: 6px solid transparent;
    border-right: 6px solid transparent;
    background-clip: padding-box;
}

.select-custom-scrollbar::-webkit-scrollbar-track {
    width: 6px;
    background-color: #E7E7EE;
    border-top: 6px solid transparent;
    border-bottom: 6px solid transparent;
    border-right: 6px solid transparent;
    background-clip: padding-box;
}

.select-custom-scrollbar::-webkit-scrollbar-thumb {
    width: 100%;
    background-color: #C4C4CD;
    border-top: 6px solid transparent;
    border-bottom: 6px solid transparent;
    border-right: 6px solid transparent;
    background-clip: padding-box;
}

/* card 영역 */
.card {
    margin-bottom: 2rem;
    border-radius: 30px;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.05);
    font-family: 'NanumGothic';
}

/* .card>.card-body {
    padding-top: max(2rem, 1.5625vw);
    padding-left: 2.0833vw;
    padding-right: 2.0833vw;
} */

/* chatter list 영역 */
.card.list {
    margin-bottom: 2rem;
    border-radius: 30px;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.05);
}

.card.post-list .card-header {
    padding-top: max(2rem, 1.5625vw);
    padding-left: 2.0833vw;
    padding-right: 2.0833vw;
    padding-bottom: 1erm;
    border-radius: 30px 30px 0 0;
    border-bottom: none;
}

.card.post-list .card-header>div {
    flex-wrap: wrap;
    /* gap: 2rem; */
}

.card.post-list .card-header .title-wrap {
    display: flex;
    gap: 0 1.333rem;
}

.card.post-list .card-header h3 {
    display: flex;
    align-items: center;
    gap: 0 1.333rem;
    color: #2E2E38;
    font-family: 'NanumGothic';
    font-size: 24px;
    font-weight: 700;
    line-height: 150%;
}

.card.post-list .card-header h3>span {
    white-space: nowrap;
}

.card.post-list .card-header .btn-wrap {
    display: flex;
    gap: 0 2rem;
}

.card.post-list .card-header .btn-wrap .btn-group-area {
    position: relative;
    display: flex;
    gap: 0 0.666rem;
}

.card.post-list .card-header .btn-wrap .btn-group-area::after {
    content: '';
    display: block;
    position: absolute;
    top: 50%;
    right: -1rem;
    transform: translateY(-50%);
    width: 1px;
    height: calc(100% - 1.066rem);
    background-color: #DDDDE3;
}

.btn-more-area {
    display: flex;
    justify-content: center;
    margin-top: 2.666rem;
}

.btn-more-area .btn-view-more {
    display: inline-block;
    width: auto;
    height: auto;
    margin: 0;
    padding: 1.3rem 3.3rem 1.3rem 3.033rem;
    border-radius: 60px;
    background-color: #E7E7EE;
}

.btn-more-area .btn-view-more .icon {
    margin-top: -3px;
    margin-right: 0.533rem;
}

.btn-more-area .btn-view-more span {
    color: #2E2E38;
    font-family: 'NanumGothic';
    font-size: 14px;
    line-height: 150%;
}

.btn-more-area .btn-view-more:hover {
    background-color: #C4C4CD;
}

.toggle-line {
    /* position: relative; */
    display: block;
    width: 100%;
    height: 3rem;
    text-align: center;
}

.toggle-line::before {
    content: '';
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    width: 97%;
    height: 1px;
    background-color: #DDDDE3;
    transform: translate(-50%, -50%);
}

.filter-refresh-button {
    width: 20px;
}

.filter-refresh-button:hover {
    cursor: pointer;
}
</style>;